import { render, staticRenderFns } from "./signup-page.vue?vue&type=template&id=dd2bc7ee&scoped=true&"
import script from "./signup-page.vue?vue&type=script&lang=js&"
export * from "./signup-page.vue?vue&type=script&lang=js&"
import style0 from "./signup-page.vue?vue&type=style&index=0&id=dd2bc7ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2bc7ee",
  null
  
)

export default component.exports
import {QForm,QBtn,QSpinnerIos,QSeparator,QInput,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QBtn,QSpinnerIos,QSeparator,QInput,QIcon})
